import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    padding: theme.spacing(25, 0, 10),
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(25, 0, 5),
      marginBottom: theme.spacing(2),
    },
  },
  paperContent: {
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(0),
    },
    color: "#33658a",
    fontFamily: "Century-Gothic",
  },
  backgroundirector: {
    zIndex: -1,
    position: "absolute",
    top: "60px",
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(35, 37, 41, 0.7), rgba(35, 37, 41, 0.7)), url('/images/ceo/backgroundCeo.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "485px",
    width: "100%",
  },
  avatarImage: {
    pointerEvents: 'none',
    //objectPosition: 'top',
    width: theme.spacing(25),
    height: theme.spacing(25),
    position: "relative",
    bottom: "80px",
    //borderRadius: '50%',
    [theme.breakpoints.down("sm")]: {
      width: theme.spacing(18),
      height: theme.spacing(18),
    },
    "& > *": {
      objectPosition: "top",
    },
  },
  avatarImagee: {
    objectPosition: "top",
  },
  cardtittle: {
    fontWeight: "bold",
    color: "#33658a",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(4),
  },
  cardsubtittle: {
    fontWeight: "bold",
    color: "#33658a",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(8),
  },
  cardsocial: {
    alignSelf: "auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: theme.spacing(8),
    paddingTop: theme.spacing(5),
    "& > * + *": {
      marginLeft: theme.spacing(5),
    },
  },
  iconsocial: {
    color: "#33658a",
    fontSize: 50,
    //marginLeft: theme.spacing(2),
  },
  cardtext: {
    //fontWeight: 'bold',
    paddingBottom: theme.spacing(5),
    fontFamily: "Century-Gothic",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(3),
      textAlign: "center",
    },
  },
  cardtextLeft: {
    color: "#33658A",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(5),
    "& > *": {
      [theme.breakpoints.down("xs")]: {
        //marginBottom: theme.spacing(0), 
        textAlign: "center",
      },
    },
  },
}));
export default useStyles;
